/**
 * Query History Types
 *
 * Types for tracking and displaying query execution history per connection/database.
 */

export type QueryHistoryEntry = {
  /** Unique identifier for this history entry */
  id: string;
  /** The SQL query that was executed */
  sql: string;
  /** Connection ID where the query was executed */
  connectionId: string;
  /** Database context when query was executed */
  database?: string;
  /** When the query was executed */
  executedAt: Date;
  /** Whether the query succeeded */
  success: boolean;
  /** Number of rows returned (if successful) */
  rowCount?: number;
  /** Execution time in milliseconds */
  executionTimeMs?: number;
  /** Error message if query failed */
  errorMessage?: string;
  /** Human-readable connection name (for display when connection is deleted) */
  connectionName?: string;
  /** Engine ID at time of execution (for display when connection is deleted) */
  engineId?: string;
};

export type QueryHistoryContextKey = string; // Format: `${connectionId}:${database || 'default'}`

/**
 * Create a context key for query history lookup
 */
export function createHistoryContextKey(connectionId: string, database?: string): QueryHistoryContextKey {
  return `${connectionId}:${database || 'default'}`;
}

/**
 * Generate a unique ID for a history entry
 */
export function createHistoryEntryId(): string {
  return `qh-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
